import { BankInterfaceMonitoringMaintenanceConstant } from "presentation/constant/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useBankInterfaceMonitoringMaintenanceVM } from "presentation/hook/BankInterfaceMonitoring/useBankInterfaceMonitoringMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";

import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHInputTextarea, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const BankInterfaceMonitoringMainFormPanel = () => {
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();
    const bankInterfaceMonitoringVM = useBankInterfaceMonitoringMaintenanceVM();
    const BANK_MONITORING_CONST = BankInterfaceMonitoringMaintenanceConstant;
    const currentBankInterfaceMonitoringEty = bankInterfaceMonitoringState.currentBankInterfaceMonitoringEty;
    const [isLoading, setIsLoading] = useState(false);
    const { dynamicOptions } = bankInterfaceMonitoringState;
    const { isSaveClicked } = bankInterfaceMonitoringState.viewState
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit, allowUpdate } = anaInfoState;
    const messageBarVM = useMessageBarVM();

    // const onFieldChange = useCallback((e: any, fieldName: string) => {
    //     const fieldValue = e.target.value;
    //     bankInterfaceMonitoringVM.onFieldChange(fieldName, fieldValue);
    // }, [bankInterfaceMonitoringVM]);

    const handleCancelClick = useCallback(() => {
        bankInterfaceMonitoringVM.onCancel();
    }, [bankInterfaceMonitoringVM])

    const handleResendClick = useCallback(() => {
        bankInterfaceMonitoringVM.onResend(currentBankInterfaceMonitoringEty).then((data) => {
            if (data.success) {
                messageBarVM.showSuccess("Resend Successfully.");
                bankInterfaceMonitoringVM.onSearch(bankInterfaceMonitoringState.searchCriteria).then(() => {
                    setIsLoading(false);
                }).catch((error) => {
                    setIsLoading(false);
                });
            } else {
                messageBarVM.showError(data.data ?? "Resend Failed.");
                setIsLoading(false);
                return;
            }
        }).catch((error) => {
            setIsLoading(false);
            messageBarVM.showError('Resend Failed.');
        });
        setIsLoading(false);
    }, [bankInterfaceMonitoringState.searchCriteria, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty, messageBarVM])

    const isResendDisable = useCallback(() => {
        if (currentBankInterfaceMonitoringEty.messageType !== "INV" || !(currentBankInterfaceMonitoringEty.status === 'REJECT' || currentBankInterfaceMonitoringEty.status === 'ERROR')) {
            return true;
        }
        return false;
    }, [currentBankInterfaceMonitoringEty])


    const memoMessageTextValue = useMemo(() => {
        let messageText1: string = "";
        let messageText2: string = "";
        let messageText3: string = "";
        let messageText4: string = "";
        let messageText5: string = "";
        let messageText6: string = "";
        let messageText7: string = "";
        let messageText8: string = "";
        let messageText9: string = "";
        let messageText10: string = "";

        if (currentBankInterfaceMonitoringEty?.messageType === "INV") {
            messageText1 = `${BANK_MONITORING_CONST.DRAFT_INVOICE_ID}: ${currentBankInterfaceMonitoringEty?.draftInvoiceId ?? ""}`;
            messageText2 = `${BANK_MONITORING_CONST.AMOUNT}: ${currentBankInterfaceMonitoringEty?.amount ?? ""}`;
            messageText3 = `${BANK_MONITORING_CONST.CUSTOMER_ID}: ${currentBankInterfaceMonitoringEty?.customerId ?? ""}`;
            messageText4 = `${BANK_MONITORING_CONST.CUSTOMER_NAME}: ${currentBankInterfaceMonitoringEty?.customerName ?? ""}`;
            messageText5 = `${BANK_MONITORING_CONST.CUSTOMER_ACC_NUMBER}: ${currentBankInterfaceMonitoringEty?.customerAccountNumber ?? ""}`;
            messageText6 = `${BANK_MONITORING_CONST.TRANSACTION_DATE}: ${currentBankInterfaceMonitoringEty?.transactionDate ?? ""}`;
            messageText7 = `${BANK_MONITORING_CONST.OP_TYPE}: ${currentBankInterfaceMonitoringEty?.opType ?? ""}`;
            messageText8 = `${BANK_MONITORING_CONST.BL_NBR}: ${currentBankInterfaceMonitoringEty?.blNbr ?? ""}`;
            messageText9 = `${BANK_MONITORING_CONST.RECORD_ERROR_CODE}: ${currentBankInterfaceMonitoringEty?.recordErrorCode ?? ""}`;

            const messageText = messageText1 + "\n" +
                messageText2 + "\n" +
                messageText3 + "\n" +
                messageText4 + "\n" +
                messageText5 + "\n" +
                messageText6 + "\n" +
                messageText7 + "\n" +
                messageText8 + "\n" +
                messageText9;
            return messageText;
        } else if (currentBankInterfaceMonitoringEty?.messageType === "HAKI") {
            messageText1 = `${BANK_MONITORING_CONST.DRAFT_INVOICE_ID}: ${currentBankInterfaceMonitoringEty?.draftInvoiceId ?? ""}`;
            messageText2 = `${BANK_MONITORING_CONST.FILE_NAME}: ${currentBankInterfaceMonitoringEty?.filename ?? ""}`;
            messageText3 = `${BANK_MONITORING_CONST.AMOUNT}: ${currentBankInterfaceMonitoringEty?.amount ?? ""}`;
            messageText4 = `${BANK_MONITORING_CONST.CUSTOMER_ID}: ${currentBankInterfaceMonitoringEty?.customerId ?? ""}`;
            messageText5 = `${BANK_MONITORING_CONST.CUSTOMER_NAME}: ${currentBankInterfaceMonitoringEty?.customerName ?? ""}`;
            messageText6 = `${BANK_MONITORING_CONST.CUSTOMER_ACC_NUMBER}: ${currentBankInterfaceMonitoringEty?.customerAccountNumber ?? ""}`;
            messageText7 = `${BANK_MONITORING_CONST.STATUS}: ${currentBankInterfaceMonitoringEty?.status ?? ""}`;
            messageText8 = `${BANK_MONITORING_CONST.OP_TYPE}: ${currentBankInterfaceMonitoringEty?.opType ?? ""}`;
            messageText9 = `${BANK_MONITORING_CONST.RECORD_ERROR_CODE}: ${currentBankInterfaceMonitoringEty?.recordErrorCode ?? ""}`;
            messageText10 = `${BANK_MONITORING_CONST.PERFORMED}: ${currentBankInterfaceMonitoringEty?.performed ?? ""}`;

            const messageText = messageText1 + "\n" +
                messageText2 + "\n" +
                messageText3 + "\n" +
                messageText4 + "\n" +
                messageText5 + "\n" +
                messageText6 + "\n" +
                messageText7 + "\n" +
                messageText8 + "\n" +
                messageText9 + "\n" +
                messageText10;
            return messageText;
        } else if (currentBankInterfaceMonitoringEty?.messageType === "HMB") {
            let accountNumber = (operatingUnit === "KICT" ? `${BANK_MONITORING_CONST.KICT_AC_NBR}` : `${BANK_MONITORING_CONST.SAPT_AC_NBR}`)
            messageText1 = `${BANK_MONITORING_CONST.TRANSACTION_NBR}: ${currentBankInterfaceMonitoringEty?.transactionNumber ?? ""}`;
            messageText2 = `${accountNumber}: ${currentBankInterfaceMonitoringEty?.saptAccountNumber ?? ""}`;
            messageText3 = `${BANK_MONITORING_CONST.DRAFT_INVOICE_ID}: ${currentBankInterfaceMonitoringEty?.draftInvoiceId ?? ""}`;
            messageText4 = `${BANK_MONITORING_CONST.AMOUNT}: ${currentBankInterfaceMonitoringEty?.amount ?? ""}`;
            messageText5 = `${BANK_MONITORING_CONST.BRANCH_CODE_NAME}: ${currentBankInterfaceMonitoringEty?.branchCodeName ?? ""}`;
            messageText6 = `${BANK_MONITORING_CONST.CUSTOMER_ACC_NUMBER}: ${currentBankInterfaceMonitoringEty?.customerAccountNumber ?? ""}`;
            messageText7 = `${BANK_MONITORING_CONST.COLLECTION_TYPE}: ${currentBankInterfaceMonitoringEty?.collectionType ?? ""}`;
            messageText8 = `${BANK_MONITORING_CONST.RECEIVED_BY}: ${currentBankInterfaceMonitoringEty?.receivedBy ?? ""}`;
            messageText9 = `${BANK_MONITORING_CONST.TRANSACTION_DATE}: ${currentBankInterfaceMonitoringEty?.transactionDate ?? ""}`;
            messageText10 = `${BANK_MONITORING_CONST.OP_TYPE}: ${currentBankInterfaceMonitoringEty?.opType ?? ""}`;

            const messageText = messageText1 + "\n" +
                messageText2 + "\n" +
                messageText3 + "\n" +
                messageText4 + "\n" +
                messageText5 + "\n" +
                messageText6 + "\n" +
                messageText7 + "\n" +
                messageText8 + "\n" +
                messageText9 + "\n" +
                messageText10;
            return messageText;
        } else if (currentBankInterfaceMonitoringEty?.messageType === "HAKC") {

            messageText1 = `${BANK_MONITORING_CONST.TRANSACTION_NBR}: ${currentBankInterfaceMonitoringEty?.transactionNumber ?? ""}`;
            messageText2 = `${BANK_MONITORING_CONST.DRAFT_INVOICE_ID}: ${currentBankInterfaceMonitoringEty?.draftInvoiceId ?? ""}`;
            messageText3 = `${BANK_MONITORING_CONST.BRANCH_CODE_NAME}: ${currentBankInterfaceMonitoringEty?.branchCodeName ?? ""}`;
            messageText4 = `${BANK_MONITORING_CONST.TRANSACTION_DATE}: ${currentBankInterfaceMonitoringEty?.transactionDate ?? ""}`;
            messageText5 = `${BANK_MONITORING_CONST.FILE_NAME}: ${currentBankInterfaceMonitoringEty?.filename ?? ""}`;
            messageText6 = `${BANK_MONITORING_CONST.STATUS}: ${currentBankInterfaceMonitoringEty?.status ?? ""}`;
            messageText7 = `${BANK_MONITORING_CONST.RECORD_ERROR_CODE}: ${currentBankInterfaceMonitoringEty?.recordErrorCode ?? ""}`;
            messageText8 = `${BANK_MONITORING_CONST.PERFORMED}: ${currentBankInterfaceMonitoringEty?.performed ?? ""}`;

            const messageText = messageText1 + "\n" +
                messageText2 + "\n" +
                messageText3 + "\n" +
                messageText4 + "\n" +
                messageText5 + "\n" +
                messageText6 + "\n" +
                messageText7 + "\n" +
                messageText8;
            return messageText;
        }

    }, [BANK_MONITORING_CONST.AMOUNT, BANK_MONITORING_CONST.BL_NBR, BANK_MONITORING_CONST.BRANCH_CODE_NAME, BANK_MONITORING_CONST.COLLECTION_TYPE, BANK_MONITORING_CONST.CUSTOMER_ACC_NUMBER, BANK_MONITORING_CONST.CUSTOMER_ID, BANK_MONITORING_CONST.CUSTOMER_NAME, BANK_MONITORING_CONST.DRAFT_INVOICE_ID, BANK_MONITORING_CONST.FILE_NAME, BANK_MONITORING_CONST.KICT_AC_NBR, BANK_MONITORING_CONST.OP_TYPE, BANK_MONITORING_CONST.PERFORMED, BANK_MONITORING_CONST.RECEIVED_BY, BANK_MONITORING_CONST.RECORD_ERROR_CODE, BANK_MONITORING_CONST.SAPT_AC_NBR, BANK_MONITORING_CONST.STATUS, BANK_MONITORING_CONST.TRANSACTION_DATE, BANK_MONITORING_CONST.TRANSACTION_NBR, currentBankInterfaceMonitoringEty?.amount, currentBankInterfaceMonitoringEty?.blNbr, currentBankInterfaceMonitoringEty?.branchCodeName, currentBankInterfaceMonitoringEty?.collectionType, currentBankInterfaceMonitoringEty?.customerAccountNumber, currentBankInterfaceMonitoringEty?.customerId, currentBankInterfaceMonitoringEty?.customerName, currentBankInterfaceMonitoringEty?.draftInvoiceId, currentBankInterfaceMonitoringEty?.filename, currentBankInterfaceMonitoringEty?.messageType, currentBankInterfaceMonitoringEty?.opType, currentBankInterfaceMonitoringEty?.performed, currentBankInterfaceMonitoringEty?.receivedBy, currentBankInterfaceMonitoringEty?.recordErrorCode, currentBankInterfaceMonitoringEty?.saptAccountNumber, currentBankInterfaceMonitoringEty?.status, currentBankInterfaceMonitoringEty?.transactionDate, currentBankInterfaceMonitoringEty?.transactionNumber, operatingUnit])


    const memoMessageType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                //disableInput={true}
                isSaveClicked={isSaveClicked}
                readOnlyValue={currentBankInterfaceMonitoringEty?.messageType ?? ''}
                fieldValue={currentBankInterfaceMonitoringEty?.messageType ?? ''}
                fieldLabel={BANK_MONITORING_CONST.MESSAGE_TYPE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'messageType'}
                options={dynamicOptions.messageTypeDropdownOptions}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    bankInterfaceMonitoringVM.onFieldChange(fieldKey, fieldValue)} />
        </div>
        , [BANK_MONITORING_CONST.MESSAGE_TYPE, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty?.messageType, dynamicOptions.messageTypeDropdownOptions, isSaveClicked])

    const memoFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                //disableInput={true}
                isSaveClicked={isSaveClicked}
                readOnlyValue={currentBankInterfaceMonitoringEty?.from ?? ''}
                fieldValue={currentBankInterfaceMonitoringEty?.from ?? ''}
                fieldLabel={BANK_MONITORING_CONST.FROM}
                fieldType={FieldType.TEXT}
                fieldKey={'from'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    bankInterfaceMonitoringVM.onFieldChange(fieldKey, fieldValue)} />
        </div>
        , [BANK_MONITORING_CONST.FROM, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty?.from, isSaveClicked])

    const memoTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                //disableInput={true}
                isSaveClicked={isSaveClicked}
                readOnlyValue={currentBankInterfaceMonitoringEty?.to ?? ''}
                fieldValue={currentBankInterfaceMonitoringEty?.to ?? ''}
                fieldLabel={BANK_MONITORING_CONST.TO}
                fieldType={FieldType.TEXT}
                fieldKey={'to'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    bankInterfaceMonitoringVM.onFieldChange(fieldKey, fieldValue)} />
        </div>
        , [BANK_MONITORING_CONST.TO, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty?.to, isSaveClicked])


    const memoSendReceiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <DateTimePickerComponent
                disabled={true}
                label={BANK_MONITORING_CONST.SEND_RECEIVE_DATE}
                width="180px"
                date={currentBankInterfaceMonitoringEty?.sendReceiveDate ?? null}
                fieldName="sendReceiveDate"
                onDateChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    bankInterfaceMonitoringVM.onFieldChange(fieldKey, fieldValue)/*(e) => onFieldChange(e, 'signOnDate')*/} />
        </div>
        , [BANK_MONITORING_CONST.SEND_RECEIVE_DATE, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty?.sendReceiveDate])


    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                //disableInput={true}
                isSaveClicked={isSaveClicked}
                readOnlyValue={currentBankInterfaceMonitoringEty?.status ?? ''}
                fieldValue={currentBankInterfaceMonitoringEty?.status ?? ''}
                fieldLabel={BANK_MONITORING_CONST.STATUS}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'status'}
                options={dynamicOptions.statusDropdownOptions}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue) =>
                    bankInterfaceMonitoringVM.onFieldChange(fieldKey, fieldValue)} />
        </div>
        , [BANK_MONITORING_CONST.STATUS, bankInterfaceMonitoringVM, currentBankInterfaceMonitoringEty?.status, dynamicOptions.statusDropdownOptions, isSaveClicked])

    const memoMessage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "600px", height: "300px", marginBottom: "24px" }}>
            <HPHInputTextarea
                label={BANK_MONITORING_CONST.MESSAGE}
                width="600px"
                rows={20}
                autoExpand={true}
                disabled={true}
                resizable={false}
                helpIcon={false}
                value={memoMessageTextValue ?? ''}
                onChange={() => { }} />
        </div>
        , [BANK_MONITORING_CONST.MESSAGE, memoMessageTextValue])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{'Bank Interface Monitoring Information'}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoMessageType}
                            {memoFrom}
                            {memoTo}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoSendReceiveDate}
                            {memoStatus}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoMessage}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>

            <div className='im-charge-data-search-criteria-buttons'>
                {
                    <>
                        <HPHButton label={'Cancel'} size={'Small'} theme={'Secondary'} onClick={() => handleCancelClick()} />
                        {allowUpdate && <HPHButton label={WorkspaceConstant.Common.BUTTON_RESEND} disabled={isResendDisable()} size={'Small'} theme={'Primary'} onClick={() => handleResendClick()} />}
                    </>
                }
            </div>

        </div>
    )
}
export default memo(BankInterfaceMonitoringMainFormPanel);